import { receiveResource, createResource } from '@/plugins/resource/resource'
import cancellablePromiseProxy from '@aspectus/cancellable-promise-proxy';

const FIRST_PAGE_OFFSET = 0;

interface Parent {
  search: any; // Replace 'any' with the actual type of 'search'
  loading: boolean;
  pagination: {
    offset: number;
    limit: number;
  };
  options: any[]; // Replace 'any' with the actual type of 'options'
  params: any; // Replace 'any' with the actual type of 'params'
  filter?: (item: any) => any; // Replace 'any' with the actual type of 'item' and 'filter'
}

export const findParent = (fields: any[], field: string): Parent | undefined => {
  const parentIndex = fields.findIndex(el => el.name === field);
  const parent = fields[parentIndex];
  return parent;
};

export const saveSearchInfo = (parent: Partial<Parent>, event: any, visible: boolean|null): number => {
  parent.search = event;
  parent.loading = true;
  let offset = (parent.pagination?.offset ?? 0) + (parent.pagination?.limit ?? 0);
  if (!visible) offset = FIRST_PAGE_OFFSET;
  return offset;
};

export const saveResults = (parent: Partial<Parent>, visible: boolean|null, data: any): void => {
  parent.loading = false;
  if (data.pagination) {
    const items = parent.filter ? data.items.filter(parent.filter) : data.items;
    parent.pagination = data.pagination;
    if (visible) {
      parent.options ??= [];
      parent.options.push(...items);
      return;
    }
    parent.options = items;
    return;
  }
  parent.options = data?.items || data;
};

// let currentRequest: any = null;

const makeRequest = async (resourceUrl: string, search: any, offset: number, params: any, field): Promise<any> => {
  if (field.currentRequest) field.currentRequest.cancel();
  const cancelController = new AbortController();
  const base = receiveResource.config('signal', cancelController.signal);
  const resource = createResource(resourceUrl, base);

  return new Promise((res, rej) => {
    field.currentRequest = cancellablePromiseProxy(
      new Promise((resolve, reject) => {
        resource.execute({
          search,
          offset,
          limit: 50,
          ...params,
        })
          .then(resolve, reject);
      }),
      { cancelController }
    ).then((data : any) => {
      res(data);
    }, err => rej(err));
  });
};

export const useOptionsGetterForField = async (
  resourceUrl: string, event: any, field: Partial<Parent>, visible: boolean|null
): Promise<void> => {
  if (false === visible) return;
  const parent = field;

  const offset = saveSearchInfo(parent, event, visible);

  const resource = `${resourceUrl}{?offset,limit,search,id*}`;

  const data = await makeRequest(resource, parent?.search, offset, {}, field);

  saveResults(parent, visible, data);
};

export const useOptionsGetterForFields = async (
  resourceUrl: string,
  event: any,
  field: string,
  visible: boolean,
  fields: any[]
): Promise<void> => {
  if (false === visible) return;

  const parent: Parent | undefined = findParent(fields, field);

  if (!parent) return

  const offset = saveSearchInfo(parent, event, visible);

  const data = await makeRequest(resourceUrl, parent?.search, offset, parent.params, parent);

  saveResults(parent, visible, data);
};
